import State from './State';

window.addEventListener('load', () => State.game.render());
